// Both settings are required: skipOnVariables itself runs the nesting matcher.
export const literalInterpolation = {
  interpolation: { skipOnVariables: false },
  nest: false,
} as const;
